import {
    HIDE_BULK_ACTION_MODALS,
    HideBulkActionModals,
    SET_MODAL_DATA,
    SET_OUT_OF_SYNC_IDS,
    SET_PAYLOAD,
    SetModalData,
    SetOutOfSyncIds,
    SetPayload,
    SHOW_BULK_ACTION_MODAL,
    ShowBulkActionModal,
} from '../constants/reducers/bulk_actions'
import type { EntityId } from '../types/constants'

export const setPayload = (payload: any): SetPayload => ({
    type: SET_PAYLOAD,
    payload,
    receivedAt: Date.now(),
})

export const setOutOfSyncIds = (outOfSyncIds: EntityId[]): SetOutOfSyncIds => ({
    type: SET_OUT_OF_SYNC_IDS,
    outOfSyncIds,
    receivedAt: Date.now(),
})

export const setModalData = (data: any): SetModalData => ({
    type: SET_MODAL_DATA,
    data,
    receivedAt: Date.now(),
})

export const showBulkActionModal = (modal: string): ShowBulkActionModal => ({
    type: SHOW_BULK_ACTION_MODAL,
    modal,
    receivedAt: Date.now(),
})

export const hideBulkActionModals = (): HideBulkActionModals => ({
    type: HIDE_BULK_ACTION_MODALS,
    receivedAt: Date.now(),
})
